<template>
    <div id="contentcontainter" class="standard-mode chat-flex-container">
        <!-- Chat-Auswahl + Neuer Chat (nur intern, nicht /kai) -->
        <!-- <v-toolbar v-if="!isPublic" dense flat class="mb-2">
            <div class="d-flex align-center" style="width: 100%">
                <div class="subtitle-2 mr-3">Chats</div>
                <v-spacer />
                <v-btn small color="primary" @click="startNewChat(true)" :disabled="loading"> <v-icon left>mdi-plus</v-icon> Neuer Chat </v-btn>
            </div>
        </v-toolbar>

        <div v-if="!isPublic" class="chat-tiles mb-4">
            <v-card
                v-for="tile in chatTiles"
                :key="tile.chat.id || tile.idx"
                class="chat-tile"
                :elevation="activeChatIndex === tile.idx ? 6 : 2"
                :class="[{ 'active-chat-card': activeChatIndex === tile.idx }, { 'disabled-card': loading }]"
                @click="chooseChat(tile.idx)">
                <v-card-title class="py-2 pr-1">
                    <div class="tile-title text-truncate" :title="tile.chat.title || chatTitle(tile.chat)">
                        {{ tile.chat.title || chatTitle(tile.chat) }}
                    </div>
                    <v-spacer />
                    <v-btn icon small @click.stop="openEditChat(tile.idx)" :disabled="loading" :title="'Titel bearbeiten'">
                        <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon small color="red" @click.stop="deleteChat(tile.idx)" :disabled="loading" :title="'Chat löschen'">
                        <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-subtitle class="py-0 px-4"> {{ (tile.chat.messages && tile.chat.messages.length) || 0 }} Messages • {{ formatDate(tile.chat.created) }} </v-card-subtitle>
            </v-card>
        </div> -->
        <v-container fluid class="pa-0">
            <v-row no-gutters align="stretch">
                <v-col cols="12" md="10" sm="8">
                    <v-slide-x-transition hide-on-leave>
                        <div v-if="messages.length === 0" class="aimainwrap align-center justify-center" style="max-width: 1200px; margin: auto; padding: 20px; margin-top: 75px; width: 100%">
                            <div class="intro">
                                <h1 class="" style="text-align: center; font-family: CalSans, sans-serif; font-weight: 400">Any SEO task to do?</h1>
                            </div>
                            <div class="intro-text">
                                <!-- <p>Ask me anything about SEO, I can help you with keyword research, content optimization, technical SEO and more. Just type your question below and I will do my best to assist you.</p> -->
                                <v-chip-group>
                                    <v-chip
                                        @click="input = prompt_example"
                                        color="primary"
                                        v-for="(prompt_example, i) in prompt_examples"
                                        :key="i"
                                        close-icon="mdi-close-circle-outline"
                                        filter-icon="mdi-check-circle">
                                        <span> {{ prompt_example }}</span>
                                    </v-chip>
                                </v-chip-group>
                                <div class="py-2 px-3">
                                    <!-- Erster Textbereich (Intro) -->
                                    <v-textarea
                                        class="promptinput"
                                        :rows="3"
                                        v-model="input"
                                        filled
                                        hide-details
                                        rounded
                                        placeholder="Ask me anything about SEO. In any language..."
                                        @keyup.enter="handleSend"
                                        :counter="maxInputLength"
                                        :maxlength="maxInputLength"
                                        style="flex: 1">
                                        <template v-slot:prepend>
                                            <div style="display: flex; flex-direction: column; align-items: center; gap: 5px">
                                                <v-btn
                                                    icon
                                                    color="primary"
                                                    @click="startVoiceInput"
                                                    :disabled="recognizing || loading"
                                                    :title="recognizing ? 'Spracheingabe läuft...' : 'Spracheingabe starten'">
                                                    <v-icon v-if="!recognizing">mdi-microphone</v-icon>
                                                    <v-icon v-else color="red">mdi-microphone-off</v-icon>
                                                </v-btn>
                                                <v-btn icon color="primary" @click="triggerFileInput" :disabled="true" title="Datei anhängen">
                                                    <v-icon>mdi-paperclip</v-icon>
                                                </v-btn>
                                                <input ref="fileInput" type="file" style="display: none" @change="onFileSelected" />
                                            </div>
                                        </template>
                                        <template v-slot:append-outer>
                                            <div style="display: flex">
                                                <v-btn class="ma-auto" icon color="primary" @click="handleSend" :disabled="!input || loading">
                                                    <v-icon>mdi-send</v-icon>
                                                </v-btn>
                                                <v-btn v-if="loading" class="ma-auto" icon color="red" @click="cancelRequest" :title="'Abbrechen'">
                                                    <v-icon>mdi-close-circle</v-icon>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-textarea>
                                </div>
                            </div>
                        </div>
                    </v-slide-x-transition>
                    <v-slide-y-reverse-transition>
                        <div v-if="messages.length" class="d-flex flex-column chat-messages-container" style="max-width: 1200px; margin: auto; width: 100%">
                            <div class="chat-messages-scroll" style="flex: 1 1 auto; overflow-y: auto">
                                <div v-for="(msg, i) in messages" :key="i" class="mb-0 d-flex" :class="msg.user === 'KI' ? 'chat-row-left' : 'ml-auto'">
                                    <template v-if="msg.user === 'KI'">
                                        <v-avatar height="32px" width="32px" min-width="32px" class="comment-avat white--text mr-2" style="background: #009f89">KI</v-avatar>
                                        <div class="comment-area ki-message" style="width: 100%; overflow-x: hidden">
                                            <v-list-item-title>
                                                <span class="comment-user">KI</span>
                                                <span class="comment-date">{{ formatDate(msg.date) }}</span>
                                            </v-list-item-title>
                                            <div class="comment-text2" v-html="renderMarkdown(msg.text)"></div>

                                            <!-- Datenquellen gebündelt: eine einklappbare Zeile statt je Tool-Aufruf eine Überschrift +
                                                 Button; gleichartige Aufrufe (z. B. 18x list_ai_project_reports) als eine Zeile mit Anzahl. -->
                                            <div v-if="msg.tables && msg.tables.length" class="chat-sources mt-2">
                                                <div class="chat-sources-head" @click="toggleSources(i)">
                                                    <v-icon small class="mr-1" color="primary">mdi-database-outline</v-icon>
                                                    <span class="font-weight-medium">Sources</span>
                                                    <span class="chat-sources-meta">{{ sourcesSummary(msg.tables) }}</span>
                                                    <v-icon small class="ml-1">{{ sourcesOpen(i) ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                                                </div>
                                                <div v-if="sourcesOpen(i)" class="chat-sources-list">
                                                    <div v-for="group in groupSources(msg.tables)" :key="group.name" class="chat-source-row">
                                                        <span class="chat-source-name" :title="group.name">{{ group.label }}</span>
                                                        <span v-if="group.count > 1" class="chat-source-badge">×{{ group.count }}</span>
                                                        <!-- aendernde Aufrufe: was wurde angelegt, geaendert oder geloescht (Namen statt IDs) -->
                                                        <span v-if="group.details && group.details.length" class="chat-source-details" :title="group.details.join('\n')">{{
                                                            group.details.join(" · ")
                                                        }}</span>
                                                        <span v-if="!isWriteSource(group.name)" class="chat-source-rows">{{ group.rowCount ? group.rowCount + (group.rowCount === 1 ? " row" : " rows") : "no data" }}</span>
                                                        <!-- Lösch-/Entfernen-Aufrufe liefern nur eine Erfolgsmeldung - als Tabelle sinnlos, daher nur Rohdaten -->
                                                        <v-btn
                                                            v-if="!isWriteSource(group.name)"
                                                            x-small
                                                            text
                                                            color="primary"
                                                            class="ml-auto"
                                                            :disabled="!group.rowCount"
                                                            :loading="loadingTable[group.cacheKey]"
                                                            @click.stop="showTable(group)">
                                                            <v-icon x-small left>mdi-chart-variant</v-icon>
                                                            Visualize
                                                        </v-btn>
                                                        <v-btn x-small text :class="{ 'ml-auto': isWriteSource(group.name) }" @click.stop="showRawSource(group)">
                                                            <v-icon x-small left>mdi-code-json</v-icon>
                                                            Raw
                                                        </v-btn>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Verbrauch dieser Antwort (nur anteilig > 0) -->
                                            <div v-if="creditsText(msg)" class="chat-credits mt-1">
                                                <v-icon x-small class="mr-1">mdi-database-minus-outline</v-icon>
                                                <span>{{ creditsText(msg) }}</span>
                                            </div>

                                            <!-- Teil 14: Löschen/Entfernen/Veröffentlichen läuft erst nach Klick (OpenAI mcp_approval_request) -->
                                            <div v-if="msg.approval" class="chat-approval mt-2">
                                                <div v-for="req in msg.approval.requests" :key="req.id" class="chat-approval-item">
                                                    <v-icon small class="mr-1" :color="req.name.indexOf('publish_') === 0 ? 'primary' : 'error'">{{
                                                        req.name.indexOf("publish_") === 0 ? "mdi-earth" : "mdi-delete-outline"
                                                    }}</v-icon>
                                                    <span class="font-weight-bold">{{ req.label }}</span>
                                                    <span v-if="req.details" class="grey--text text--darken-1"> – {{ req.details }}</span>
                                                    <!-- Sammel-Löschen (delete_objects): jedes Objekt als eigene Zeile -->
                                                    <ul v-if="req.items && req.items.length" class="chat-approval-objects">
                                                        <li v-for="(item, itemIdx) in req.items" :key="itemIdx">{{ item }}</li>
                                                    </ul>
                                                </div>
                                                <div v-if="approvalIsOpen(msg)" class="mt-2">
                                                    <v-btn small rounded depressed color="primary" class="mr-2" :disabled="loading" @click="answerApproval(msg, true)">
                                                        <v-icon small left>mdi-check</v-icon>
                                                        Confirm
                                                    </v-btn>
                                                    <v-btn small rounded text :disabled="loading" @click="answerApproval(msg, false)">Cancel</v-btn>
                                                </div>
                                                <div v-else class="chat-approval-state mt-2" :class="'chat-approval-state--' + approvalStateKind(msg)">
                                                    <v-icon small class="mr-1" :color="approvalStateColor(msg)">{{ approvalStateIcon(msg) }}</v-icon>
                                                    <span>{{ approvalStateText(msg) }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="comment-area user-message">
                                            <v-list-item-title class="justify-end">
                                                <span class="comment-user">{{ msg.user }}</span>
                                                <span class="comment-date">{{ formatDate(msg.date) }}</span>
                                            </v-list-item-title>
                                            <div class="comment-text2">{{ msg.text }}</div>
                                        </div>
                                        <v-avatar
                                            height="32px"
                                            width="32px"
                                            min-width="32px"
                                            class="comment-avat white--text ml-2"
                                            :style="{ backgroundColor: $helpers ? $helpers.stringToBackgroundColor(msg.user) : '#1976d2' }"
                                            >{{ $helpers ? $helpers.getInitials(msg.user) : msg.user.substr(0, 2).toUpperCase() }}</v-avatar
                                        >
                                    </template>
                                </div>
                                <!-- Ladeanzeige -->
                                <div v-if="loading" class="mb-3 d-flex">
                                    <v-avatar height="32px" width="32px" min-width="32px" class="comment-avat white--text mr-2" style="background: #009f89"> KI </v-avatar>
                                    <div class="comment-area">
                                        <v-list-item-title>
                                            <span class="comment-user">KI</span>
                                            <span class="comment-date">{{ formatDate(new Date()) }}</span>
                                        </v-list-item-title>
                                        <div class="comment-text2">
                                            <v-progress-circular indeterminate size="20" width="2" color="primary" style="vertical-align: middle; margin-right: 8px" />
                                            thinking...
                                            <div v-if="slowHint" class="grey--text text--darken-1" style="font-size: 12px; margin-top: 4px">
                                                Working on it — analyses across multiple data sources can take up to two minutes.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <KITableDialog :value.sync="tableDialog" :table="selectedTable" @input="onTableDialogInput" />
                                <!-- Rohdaten einer Quelle (ungefilterte Tool-Antwort als JSON) -->
                                <v-dialog v-model="rawDialog" max-width="900" scrollable>
                                    <v-card>
                                        <v-card-title class="text-subtitle-1 py-2">
                                            <v-icon small class="mr-2" color="primary">mdi-code-json</v-icon>
                                            {{ rawDialogTitle }}
                                            <v-spacer />
                                            <v-btn small text color="primary" @click="copyRawSource">
                                                <v-icon small left>mdi-content-copy</v-icon>
                                                Copy
                                            </v-btn>
                                            <v-btn icon small @click="rawDialog = false"><v-icon>mdi-close</v-icon></v-btn>
                                        </v-card-title>
                                        <v-divider />
                                        <v-card-text class="pa-0" style="max-height: 70vh">
                                            <pre class="chat-raw-json">{{ rawDialogShown }}</pre>
                                        </v-card-text>
                                    </v-card>
                                </v-dialog>
                                <FeedbackDialog @feedbackSent="feedbackSent = true" v-if="!loading" :messages="messages" />
                            </div>
                            <div
                                class="py-2 px-3 mt-auto"
                                style="
                                    background: rgb(234 234 234 / 55%);
                                    border-radius: 16px;
                                    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
                                    backdrop-filter: blur(5px);
                                    -webkit-backdrop-filter: blur(5px);
                                    border: 1px solid rgba(255, 255, 255, 0.3);
                                ">
                                <!-- Unterer Textbereich -->
                                <v-textarea
                                    class="promptinput second"
                                    :rows="3"
                                    v-model="input"
                                    filled
                                    hide-details
                                    rounded
                                    placeholder="Ask me anything about SEO..."
                                    @keyup.enter="handleSend"
                                    style="flex: 1">
                                    <template v-slot:prepend>
                                        <div style="display: flex; flex-direction: column; align-items: center; gap: 5px">
                                            <v-btn
                                                icon
                                                color="primary"
                                                @click="startVoiceInput"
                                                :disabled="recognizing || loading"
                                                :title="recognizing ? 'Spracheingabe läuft...' : 'Spracheingabe starten'">
                                                <v-icon v-if="!recognizing">mdi-microphone</v-icon>
                                                <v-icon v-else color="red">mdi-microphone-off</v-icon>
                                            </v-btn>
                                            <v-btn icon color="primary" @click="triggerFileInput" :disabled="true" title="Datei anhängen">
                                                <v-icon>mdi-paperclip</v-icon>
                                            </v-btn>
                                            <input ref="fileInput" type="file" style="display: none" @change="onFileSelected" />
                                        </div>
                                    </template>
                                    <template v-slot:append-outer>
                                        <div style="display: flex">
                                            <v-btn class="ma-auto" icon color="primary" @click="handleSend" :disabled="!input || loading">
                                                <v-icon>mdi-send</v-icon>
                                            </v-btn>
                                            <v-btn v-if="loading" class="ma-auto" icon color="red" @click="cancelRequest" :title="'Abbrechen'">
                                                <v-icon>mdi-close-circle</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                </v-textarea>
                            </div>
                        </div>
                    </v-slide-y-reverse-transition>
                </v-col>
                <v-col cols="12" md="2" sm="4" class="chat-history-col">
                    <!-- light: die Liste liegt auf hellem Glas - auch im dunklen App-Theme dunkle Schrift (sonst weiß auf hell) -->
                    <v-card class="chat-history-card" elevation="0" light>
                        <v-card-title class="py-2 px-3" style="background-color: #eff1f3; border-top-left-radius: 12px !important; border-top-right-radius: 12px !important">
                            <h2 style="font-weight: 500; font-size: 1.1rem">Chats</h2>
                            <v-spacer />
                            <v-btn icon :disabled="loading" @click="startNewChat(true)" :title="'Neuer Chat'">
                                <v-icon color="primary">mdi-plus</v-icon>
                            </v-btn>
                        </v-card-title>

                        <v-card-text class="py-2 px-3">
                            <v-text-field v-model="chatSearch" dense clearable rounded outlined hide-details placeholder="Search..." prepend-inner-icon="mdi-magnify" />
                        </v-card-text>

                        <v-divider />

                        <v-list dense nav class="chat-history-list">
                            <v-list-item
                                v-for="tile in chatTilesFiltered"
                                :key="tile.chat.id || tile.idx"
                                :class="['chat-item', { active: activeChatIndex === tile.idx }]"
                                @click="chooseChat(tile.idx)">
                                <v-list-item-content>
                                    <!-- Alter über dem Titel -->
                                    <div class="chat-item-date caption" :title="formatAbsolute(tile.lastActivity)">
                                        {{ formatRelative(tile.lastActivity) }}
                                    </div>

                                    <v-list-item-title class="chat-item-title text-truncate" :title="tile.chat.title || chatTitle(tile.chat)">
                                        {{ tile.chat.title || chatTitle(tile.chat) }}
                                    </v-list-item-title>

                                    <v-list-item-subtitle class="chat-item-subtitle text-truncate-2">
                                        {{ lastMessageSnippet(tile.chat) }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action class="chat-item-actions">
                                    <v-btn icon x-small @click.stop="openEditChat(tile.idx)" :disabled="loading" :title="'Titel bearbeiten'">
                                        <v-icon small>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn icon x-small @click.stop="deleteChat(tile.idx)" :disabled="loading" :title="'Chat löschen'">
                                        <v-icon small color="red">mdi-delete</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>

                            <v-list-item v-if="!chatTilesFiltered.length">
                                <v-list-item-content>
                                    <v-list-item-title class="grey--text text--darken-1">Keine Chats</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-snackbar top color="primary" v-model="feedbackSent" :timeout="4000">
            Thank you! We will review your Feedback.

            <template v-slot:action="{ attrs }">
                <v-btn color="white" icon v-bind="attrs" @click="snackbar = false"> <v-icon>mdi-close</v-icon> </v-btn>
            </template>
        </v-snackbar>
        <!-- Kurze Rückmeldungen (Copy im Rohdaten-Dialog, Fehler bei Visualize) - $toast gibt es in dieser App nicht -->
        <v-snackbar top :color="chatInfoColor" :value="!!chatInfoMessage" :timeout="4000" @input="(open) => !open && (chatInfoMessage = '')">
            {{ chatInfoMessage }}
        </v-snackbar>
        <!-- <GoogleSignIn @login-success="onGoogleLogin" /> -->

        <!-- Edit-Dialog für Chat-Titel -->
        <v-dialog v-if="!isPublic" v-model="editDialog" max-width="480">
            <v-card>
                <v-card-title class="headline">Chat-Titel bearbeiten</v-card-title>
                <v-card-text>
                    <v-text-field v-model="editTitle" label="Titel" counter="80" :maxlength="80" autofocus />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="editDialog = false">Abbrechen</v-btn>
                    <!-- WICHTIG: Kein optional chaining im Template -->
                    <v-btn color="primary" @click="saveEditChat" :disabled="!(editTitle && editTitle.trim())">Speichern</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import MarkdownIt from "markdown-it"
    import KITableDialog from "../components/KITableDialog.vue"
    import FeedbackDialog from "../components/dialogs/FeedbackDialog.vue"
    import GoogleSignIn from "../components/GoogleLogin.vue"
    import { extractTableRows } from "../components/helper/mcpTableRows"
    import { buildIdNameMap, describeId, collectOutputs, isChangeTool } from "../components/helper/approvalNames"

    // Teil 10: AI-Chat laeuft asynchron ueber einen Server-Job statt eines blockierenden POST (siehe
    // backend chatJobController.js). sessionStorage-Key, unter dem ein laufender Job einen Reload
    // ueberlebt (nicht localStorage - ein pendender Job gehoert an den Tab, nicht an das Geraet).
    const CHAT_JOB_STORAGE_KEY = "quaro_chat_pending_job"
    // OpenAI-Timeout (300s) + Marge, bevor der Watchdog einmal nachfragt statt auf das Socket-Event zu warten.
    const CHAT_JOB_WATCHDOG_MS = 330000
    // Gebündelte Datenquellen je Nachricht (siehe groupSources) - WeakMap, damit nichts davon reaktiv wird.
    const SOURCE_GROUP_CACHE = new WeakMap()
    let sourceGroupSeq = 0
    // Rohdaten-Ansicht: ab dieser Länge wird nur der Anfang angezeigt (Copy kopiert trotzdem alles).
    const RAW_PREVIEW_CHARS = 200000

    export default {
        name: "KIChat",
        components: { KITableDialog, FeedbackDialog, GoogleSignIn },
        data() {
            return {
                prompt_examples: [
                    "What seo tasks can you do?",
                    "Do a keyword research for the topic X",
                    "How can I improve my website's SEO?",
                    "Do an on-page SEO audit for my site",
                    "Do a backlink analysis for the following websites...",
                    "Can you help me with technical SEO issues?"
                ],
                chatOpen: false,
                input: "",
                // messages: [], // Entfernen – wird computed
                publicMessages: [], // Für /kai
                unreadCount: 0,
                loading: false,
                tableVisible: {}, // <--- Sichtbarkeit pro Tabelle
                tableDialog: false,
                selectedTable: null,
                loadingTable: {}, // statt loadingTable: false
                tableDefCache: {}, // <--- Cache für Tabellen-Definitionen
                recognizing: false,
                recognition: null,
                maxInputLength: 3000, // <--- Hier die maximale Zeichenanzahl festlegen
                files: [],
                feedbackSent: false,
                // Abbrechen/Request-Steuerung
                requestController: null,
                cancelRequested: false,
                // Hinweis bei langen Analysen (mehrere Tool-Quellen) - siehe send()/sendPublic()
                slowHint: false,
                slowHintTimer: null,
                // Teil 10: laufender Chat-Job (async, ueber Socket + /v2/sources/chat-job) - siehe send()
                pendingJob: null,
                chatWatchdogTimer: null,
                chatWatchdogAttempts: 0,
                // Auf-/Zugeklappte Datenquellen je Nachricht ("<chatIndex>:<messageIndex>") - siehe sourcesOpen()
                openSources: {},
                // Rohdaten-Dialog einer Quelle (siehe showRawSource)
                rawDialog: false,
                rawDialogTitle: "",
                rawDialogShown: "",
                rawDialogFull: "",
                chatInfoMessage: "",
                chatInfoColor: "primary",
                // Neu: Editier-Dialog für Chat-Titel
                editDialog: false,
                editTitle: "",
                editChatIndex: null,
                chatSearch: ""
            }
        },
        computed: {
            chatTilesFiltered() {
                const q = (this.chatSearch || "").toLowerCase().trim()
                if (!q) return this.chatTiles
                return this.chatTiles.filter((t) => (t.chat.title || this.chatTitle(t.chat) || "").toLowerCase().includes(q))
            },
            isPublic() {
                console.log("public")
                console.log(this.$route.path)
                // Erkennung über Route oder Query-Parameter
                return this.$route.path === "/kai"
            },
            chats() {
                return this.$store.state.user_settings?.ki_chats?.chats || []
            },
            activeChatIndex() {
                return this.$store.state.user_settings?.ki_chats?.active_chat ?? 0
            },
            chatOptions() {
                return this.chats.map((c, i) => ({ text: this.chatTitle(c), value: i }))
            },
            // Neu: Immer mit Store synchron (intern) oder publicMessages (/kai)
            messages() {
                if (this.isPublic) return this.publicMessages
                const chats = this.$store.state.user_settings?.ki_chats?.chats || []
                const idx = this.$store.state.user_settings?.ki_chats?.active_chat ?? 0
                return chats[idx]?.messages || []
            },
            // Nur Chats mit mindestens 1 Nachricht als Kachel anzeigen
            chatTiles() {
                const toTs = (d) => {
                    if (!d) return 0
                    const ts = new Date(d).getTime()
                    return Number.isFinite(ts) ? ts : 0
                }
                const all = this.$store.state.user_settings?.ki_chats?.chats || []
                return all
                    .map((chat, idx) => {
                        const msgs = Array.isArray(chat.messages) ? chat.messages : []
                        const last = msgs.length ? msgs[msgs.length - 1] : null
                        const lastMsgTs = toTs(last?.date)
                        const createdTs = toTs(chat?.created)
                        const lastActivity = Math.max(lastMsgTs, createdTs)
                        return { chat, idx, lastActivity }
                    })
                    .filter((t) => Array.isArray(t.chat.messages) && t.chat.messages.length > 0)
                    .sort((a, b) => b.lastActivity - a.lastActivity)
            }
        },
        mounted() {
            console.log("this.$store.state.user_settings", this.$store.state.user_settings)
            if (!localStorage.unique_user_id) {
                const uniqueId = Math.random().toString(36).substr(2, 16) + "_" + Date.now()
                localStorage.kop = uniqueId
                document.cookie = "kop=" + uniqueId + "; path=/; max-age=31536000" // 1 Jahr gültig
            }

            if (!this.isPublic) {
                if (!this.$store.state.user_settings.ki_chats) {
                    this.$store.state.user_settings.ki_chats = { chats: [], active_chat: 0 }
                }
                // Bestehende Chats ggf. auf 30 begrenzen
                this.enforceChatLimit()
                // Sicherer Zugriff
                const firstChat = this.$store.state.user_settings.ki_chats.chats[0]
                console.log(firstChat ? firstChat.latest_resp_id : null)
                this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)
                console.log("after", firstChat ? firstChat.latest_resp_id : null)

                // Immer mit neuem, NICHT gespeicherten (ephemeren) Chat starten
                this.startNewChat(true)
            }

            // SpeechRecognition initialisieren (nur wenn verfügbar)
            if ("webkitSpeechRecognition" in window || "SpeechRecognition" in window) {
                const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
                this.recognition = new SpeechRecognition()
                this.recognition.lang = "de-DE" // oder 'en-US' je nach Bedarf
                this.recognition.continuous = false
                this.recognition.interimResults = false

                this.recognition.onresult = (event) => {
                    const transcript = event.results[0][0].transcript
                    this.input += (this.input ? " " : "") + transcript
                }
                this.recognition.onend = () => {
                    this.recognizing = false
                }
                this.recognition.onerror = () => {
                    this.recognizing = false
                }
            }
            // CSV-Export Funktion global bereitstellen (wegen onclick im HTML)
            window.exportMarkdownTableAsCSV = (tableId) => {
                const table = document.getElementById(tableId)?.querySelector("table")
                if (!table) return
                let csv = []
                for (let row of table.rows) {
                    let rowData = []
                    for (let cell of row.cells) {
                        // Zelleninhalt escapen
                        let text = cell.innerText.replace(/"/g, '""')
                        rowData.push(`"${text}"`)
                    }
                    csv.push(rowData.join(","))
                }
                const csvContent = csv.join("\n")
                const blob = new Blob([csvContent], { type: "text/csv" })
                const url = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = url
                a.download = "tabelle.csv"
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                URL.revokeObjectURL(url)
            }
            // Clipboard-Funktion
            window.copyMarkdownTableToClipboard = (tableId) => {
                const table = document.getElementById(tableId)?.querySelector("table")
                if (!table) return
                let tsv = []
                for (let row of table.rows) {
                    let rowData = []
                    for (let cell of row.cells) {
                        rowData.push(cell.innerText)
                    }
                    tsv.push(rowData.join("\t"))
                }
                const tsvContent = tsv.join("\n")
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(tsvContent)
                } else {
                    // Fallback
                    const textarea = document.createElement("textarea")
                    textarea.value = tsvContent
                    document.body.appendChild(textarea)
                    textarea.select()
                    document.execCommand("copy")
                    document.body.removeChild(textarea)
                }
            }

            // Teil 10: laeuft noch ein Chat-Job aus einer frueheren Seitenladung (Reload waehrend einer
            // Analyse), dem eigenen Raum wieder beitreten und den Status einmal nachladen - deckt sowohl
            // den Reload-Fall als auch ein waehrend der Ladezeit verpasstes Socket-Event ab.
            this.restorePendingChatJob()
            this.$socket.on("chatJobUpdate", this.onChatJobUpdate)
            this.$socket.on("connect", this.onChatSocketReconnect)
        },
        beforeDestroy() {
            this.$socket.off("chatJobUpdate", this.onChatJobUpdate)
            this.$socket.off("connect", this.onChatSocketReconnect)
            this.clearChatWatchdog()
        },
        watch: {
            chatOpen(val) {
                if (val) this.unreadCount = 0
            }
        },
        methods: {
            lastMessageSnippet(chat) {
                const msgs = Array.isArray(chat?.messages) ? chat.messages : []
                if (!msgs.length) return "Noch keine Nachrichten"
                const last = msgs[msgs.length - 1]
                const text = (last?.text || "").replace(/\s+/g, " ").trim()
                return text.length > 100 ? text.slice(0, 97) + "…" : text || "—"
            },
            formatRelative(date) {
                if (!date) return ""
                const d = new Date(date)
                if (isNaN(d.getTime())) return ""
                const now = new Date()
                const sec = Math.floor((now - d) / 1000)
                const min = Math.floor(sec / 60)
                const hrs = Math.floor(min / 60)
                const days = Math.floor(hrs / 24)
                const weeks = Math.floor(days / 7)
                const months = Math.floor(days / 30)
                const years = Math.floor(days / 365)

                if (sec < 60) return "Just now"
                if (min < 60) return `${min} min ago`
                if (hrs < 24) return `${hrs} hr${hrs === 1 ? "" : "s"} ago`
                if (days === 1) return "Yesterday"
                if (days < 7) return `${days} days ago`
                if (weeks < 5) return `${weeks} week${weeks === 1 ? "" : "s"} ago`
                if (months < 12) return `${months} month${months === 1 ? "" : "s"} ago`
                return `${years} year${years === 1 ? "" : "s"} ago`
            },
            formatAbsolute(date) {
                if (!date) return ""
                const d = new Date(date)
                if (isNaN(d.getTime())) return ""
                return d.toLocaleString("de-DE", {
                    weekday: "short",
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit"
                })
            },
            onGoogleLogin(data) {
                // Hier kannst du das Token an dein Backend schicken
                console.log("Google Login Success:", data)
            },
            onGoogleLoginError(error) {
                console.error("Google Login Error:", error)
            },
            handleSend() {
                if (this.isPublic) {
                    this.sendPublic()
                } else {
                    this.send()
                }
            },
            triggerFileInput() {
                this.$refs.fileInput.click()
            },
            onFileSelected(event) {
                console.log(event)
                const file = event.target.files[0]
                if (file) {
                    const formData = new FormData()
                    formData.append("file", file)
                    formData.append("user_id", localStorage.id)
                    formData.append("company_id", localStorage.company_id)
                    this.loading = true
                    this.$helpers
                        .axiosPost(process.env.VUE_APP_APIURL + "/v2/sources/chat/add/file", formData, { headers: { "Content-Type": "multipart/form-data" } })
                        .then((res) => {
                            console.log(res.data)
                            this.files.push(res.data.file)
                        })
                        .catch((e) => {
                            const msg = { user: "KI", text: "An error accured while uploading the file.", date: new Date() }
                            if (this.isPublic) {
                                this.publicMessages.push(msg)
                            } else {
                                // gezielt in aktiven Chat
                                this.addMessageToChat(msg, this.activeChatIndex)
                            }
                        })
                        .finally(() => {
                            this.loading = false
                        })
                }
            },
            renderMarkdown(text) {
                const md = new MarkdownIt()
                let html = md.render(text || "")

                // Tabellen mit Wrapper und Buttons (CSV & Clipboard) versehen
                html = html.replace(/(<table[\s\S]*?<\/table>)/g, (match, tableHtml, idx) => {
                    const tableId = `md-table-${Math.random().toString(36).substr(2, 9)}`
                    return `
                        <div class="md-table-wrapper" style="position:relative; overflow-x: auto;"
                            onmouseover="this.querySelectorAll('.csv-btn,.clipboard-btn').forEach(btn=>btn.style.display='block')"
                            onmouseleave="this.querySelectorAll('.csv-btn,.clipboard-btn').forEach(btn=>btn.style.display='none')">
                            <button class="csv-btn" style="display:none; position:absolute; top:8px; right:8px; z-index:2;"
                                onclick="window.exportMarkdownTableAsCSV && window.exportMarkdownTableAsCSV('${tableId}')">
                                <span class="mdi mdi-download" style="font-size:18px;"></span>
                            </button>
                            <button class="clipboard-btn" style="display:none; position:absolute; top:8px; right:48px; z-index:2;"
                                onclick="window.copyMarkdownTableToClipboard && window.copyMarkdownTableToClipboard('${tableId}')">
                                <span class="mdi mdi-content-copy" style="font-size:18px;"></span>
                            </button>
                            <div id="${tableId}">${tableHtml}</div>
                        </div>
                    `
                })
                return html
            },
            async send() {
                if (!this.input || this.loading) return
                this.cancelRequested = false
                this.requestController = new AbortController()
                const userInput = this.input
                const userMessage = {
                    user: this.getUsername(),
                    text: userInput,
                    date: new Date()
                }
                if (!this.$store.state.user_settings.ki_chats.chats.length) this.startNewChat(true)

                const targetIdx = this.$store.state.user_settings.ki_chats.active_chat
                this.addMessageToChat(userMessage, targetIdx)

                // Chat nach erster Nachricht umbenennen
                this.maybeRenameChat(targetIdx, userInput)

                this.input = ""
                // Teil 14: Hängt an der letzten Antwort noch eine unbeantwortete Freigabe, lehnt OpenAI reinen
                // Text mit 400 ab - die offenen Freigaben gehen deshalb als "abgelehnt" mit der Frage raus.
                const open = this.takeOpenApprovals(targetIdx)
                if (open.messages.length) this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)
                const ok = await this.postChatJob(
                    { question: userInput, files: this.files, ...(open.approvals.length ? { approvals: open.approvals } : {}) },
                    targetIdx,
                    open.approvals.length ? { approvalRespId: open.respId } : null
                )
                // Nicht angekommen -> die Freigaben sind bei OpenAI weiterhin offen, also auch hier wieder wie vorher
                if (!ok && open.messages.length) {
                    open.messages.forEach((entry) => (entry.message.approval.state = entry.previousState))
                    this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)
                }
            },
            // Teil 10/14: legt den Chat-Job an (Frage und/oder Freigaben) und wartet dann auf das Socket-Signal.
            // true = Job angelegt bzw. Antwort verarbeitet, false = abgebrochen oder Fehler (Meldung steht im Chat).
            // jobMeta (optional) wird am pendingJob mitgeführt - z.B. approvalRespId, damit ein gescheiterter
            // Freigabe-Job seine Freigabe-Nachricht wiederfindet (auch nach Reload, pendingJob liegt im sessionStorage).
            async postChatJob(payload, targetIdx, jobMeta) {
                this.loading = true
                // Analysen über mehrere Tool-Quellen (Quaro + DataForSEO) können deutlich länger dauern als ein
                // Ein-Tool-Lookup - nach 15s ein Hinweis, damit "thinking..." nicht wie ein Hänger wirkt.
                this.slowHint = false
                this.slowHintTimer = setTimeout(() => {
                    this.slowHint = true
                }, 15000)
                this.$nextTick(() => {
                    const el = this.$el.querySelector(".chat-messages-scroll")
                    if (el) el.scrollTop = el.scrollHeight
                })
                // Teil 10: der Chat laeuft jetzt asynchron ueber einen Server-Job (Socket-Signal + kurzer
                // Status-Abruf) statt eines langen blockierenden POST - deshalb kein Retry mehr auf
                // "Network Error": ein wiederholter POST mit derselben client_job_id ist zwar durch den
                // Upsert im Backend harmlos, ein Netzwerk-Aussetzer bei einem Request, der ohnehin nur
                // wenige hundert Millisekunden dauert (Job-Erstellung, keine Analyse mehr), heilt sich
                // nicht durch sofortiges erneutes Probieren.
                const clientJobId = this.generateClientJobId()
                let res = null
                let lastError = null
                try {
                    res = await this.$helpers.axiosPost(
                        process.env.VUE_APP_APIURL + "/v2/sources/chat",
                        {
                            user_id: localStorage.id,
                            company_id: localStorage.company_id,
                            ...payload,
                            // Freigaben gehören zu genau der Antwort, an der sie hängen (payload.resp_id), sonst die letzte des Chats
                            resp_id: payload.resp_id || this.$store.state.user_settings.ki_chats.chats[targetIdx]?.latest_resp_id || null,
                            socket_id: this.$socket.id || null, // nur informativ - die Zustellung laeuft ueber den Job-Raum
                            client_job_id: clientJobId
                        },
                        // axiosPost nimmt als drittes Argument eine Zahl (Timeout in ms), kein Options-Objekt -
                        // der Request ist nur noch die Job-Anlage, 30s sind reichlich.
                        30000
                    )
                } catch (e) {
                    if (!(this.cancelRequested || e?.name === "AbortError" || e?.code === "ERR_CANCELED")) lastError = e
                }
                this.requestController = null
                this.files = []
                if (this.cancelRequested) {
                    clearTimeout(this.slowHintTimer)
                    this.slowHint = false
                    this.loading = false
                    this.cancelRequested = false
                    return false
                }
                if (lastError) {
                    clearTimeout(this.slowHintTimer)
                    this.slowHint = false
                    this.addMessageToChat({ user: "KI", text: this.mapChatSendErrorMessage(lastError), date: new Date() }, targetIdx)
                    this.loading = false
                    this.$nextTick(() => {
                        const el = this.$el.querySelector(".v-card-text")
                        if (el) el.scrollTop = el.scrollHeight
                    })
                    return false
                }
                if (res?.data?.job_id) {
                    // Neuer, asynchroner Pfad (202): Job laeuft im Hintergrund weiter, Ergebnis kommt per
                    // chatJobUpdate-Event -> pollPendingChatJob() -> finishPendingChatJob().
                    // chatId zusaetzlich zum Index: enforceChatLimit() (shift) und ein Reload koennen die
                    // Indizes verschieben, die id des Chats bleibt - siehe resolveChatIndex().
                    const chatId = this.$store.state.user_settings.ki_chats.chats[targetIdx]?.id ?? null
                    this.pendingJob = { job_id: res.data.job_id, backend_socket_id: res.data.backend_socket_id, mode: "internal", targetIdx, chatId, ...(jobMeta || {}) }
                    this.persistPendingChatJob()
                    this.$socket.emit("joinChatJob", this.pendingJob.job_id)
                    this.startChatWatchdog()
                    return true
                }
                // Uebergangs-Sicherheit: eine (noch) nicht aktualisierte API antwortet weiterhin synchron
                // mit 200 { messages, resp_id } - direkt verarbeiten statt auf ein Job-Ergebnis zu warten.
                clearTimeout(this.slowHintTimer)
                this.slowHint = false
                this.applyChatAnswer(res?.data, { mode: "internal", targetIdx })
                this.loading = false
                return true
            },
            // ---- Teil 14: Freigabe im Chat für Löschen/Entfernen/Veröffentlichen ----
            // Klick auf Confirm/Cancel einer Freigabe-Nachricht. Der Zustand wird sofort gesetzt (Buttons weg,
            // kein Doppelklick); scheitert schon das Absenden, geht er auf "pending" zurück. Ein zweiter POST mit
            // denselben Freigaben landet serverseitig beim selben Job (approvalJobId), läuft also nie doppelt.
            async answerApproval(msg, approve) {
                if (this.loading || !this.approvalIsOpen(msg)) return
                this.cancelRequested = false
                this.requestController = new AbortController()
                const targetIdx = this.activeChatIndex
                msg.approval.state = approve ? "approved" : "declined"
                this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)
                const approvals = msg.approval.requests.map((req) => ({ approval_request_id: req.id, approve }))
                const ok = await this.postChatJob({ approvals, resp_id: msg.approval.resp_id }, targetIdx, { approvalRespId: msg.approval.resp_id })
                if (!ok) {
                    msg.approval.state = "pending"
                    this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)
                }
            },
            // Offen = noch nicht beantwortet UND an der letzten Antwort des Chats - eine Freigabe gilt nur für
            // die Response, zu der sie gehört; nach einer weiteren Frage ist sie wertlos.
            approvalIsOpen(msg) {
                if (!msg || !msg.approval || msg.approval.state !== "pending") return false
                const chat = this.chats[this.activeChatIndex]
                return Boolean(chat && chat.latest_resp_id && chat.latest_resp_id === msg.approval.resp_id)
            },
            // "1 message · 12,340 tokens · 3 research credits" - nur Anteile > 0; leer ohne Angabe (alte Nachrichten, öffentlicher Chat)
            creditsText(msg) {
                const c = msg && msg.credits
                if (!c) return ""
                const parts = []
                if (c.messages > 0) parts.push(`${c.messages} ${c.messages === 1 ? "message" : "messages"}`)
                if (c.tokens > 0) parts.push(`${this.$helpers.formatNumber(c.tokens)} tokens`)
                if (c.research_lookups > 0) parts.push(`${c.research_lookups} research ${c.research_lookups === 1 ? "credit" : "credits"}`)
                return parts.join(" · ")
            },
            // Zustand einer beantworteten Freigabe für die Anzeige: approved | declined | failed | expired
            approvalStateKind(msg) {
                const state = msg.approval.state
                return state === "approved" || state === "declined" || state === "failed" ? state : "expired"
            },
            approvalStateIcon(msg) {
                return { approved: "mdi-check-circle", declined: "mdi-close-circle", failed: "mdi-alert-circle", expired: "mdi-clock-outline" }[this.approvalStateKind(msg)]
            },
            approvalStateColor(msg) {
                return { approved: "success", declined: "grey darken-1", failed: "error", expired: "grey" }[this.approvalStateKind(msg)]
            },
            approvalStateText(msg) {
                if (msg.approval.state === "approved") return "You confirmed this action."
                if (msg.approval.state === "declined") return "You cancelled this action - nothing was changed."
                if (msg.approval.state === "failed") return "Could not be completed - it may or may not have run. Ask the chat to check before trying again."
                return "Expired - ask again if you still want to do this."
            },
            // Offene Freigaben des Chats als "abgelehnt" einsammeln (und so markieren), wenn der Nutzer weitertippt.
            // "failed" zählt mit: eine gescheiterte Ausführung hat bei OpenAI keine Antwort erzeugt, die Freigabe
            // ist dort also weiterhin offen - ohne Ablehnung endete jede weitere Frage in deren 400.
            takeOpenApprovals(chatIndex) {
                const chat = this.$store.state.user_settings?.ki_chats?.chats?.[chatIndex]
                const approvals = []
                const messages = []
                if (!chat || !Array.isArray(chat.messages) || !chat.latest_resp_id) return { approvals, messages, respId: null }
                for (const message of chat.messages) {
                    if (!message || !message.approval || message.approval.resp_id !== chat.latest_resp_id) continue
                    if (message.approval.state !== "pending" && message.approval.state !== "failed") continue
                    messages.push({ message, previousState: message.approval.state })
                    // "failed" bleibt sichtbar - ob das Tool trotzdem lief, ist offen; "nothing was changed" wäre falsch
                    if (message.approval.state === "pending") message.approval.state = "declined"
                    for (const req of message.approval.requests || []) approvals.push({ approval_request_id: req.id, approve: false })
                }
                return { approvals, messages, respId: chat.latest_resp_id }
            },
            // Ein Freigabe-Job ist gescheitert, abgebrochen oder verloren: bei OpenAI gibt es dazu keine neue
            // Antwort, die Freigabe ist dort noch offen. Als "failed" markieren - takeOpenApprovals lehnt sie
            // dann beim nächsten Tippen mit ab. Kein erneuter Confirm-Button: ob das Tool schon lief, ist unklar.
            markApprovalFailed(job) {
                if (!job || !job.approvalRespId || job.mode === "public") return
                const chat = this.$store.state.user_settings?.ki_chats?.chats?.[this.resolveChatIndex(job)]
                if (!chat || !Array.isArray(chat.messages)) return
                let changed = false
                for (const message of chat.messages) {
                    if (message && message.approval && message.approval.resp_id === job.approvalRespId && message.approval.state !== "pending") {
                        message.approval.state = "failed"
                        changed = true
                    }
                }
                if (changed) this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)
            },
            approvalLabel(name) {
                const labels = {
                    delete_ai_project: "Delete AI project",
                    delete_ai_project_report: "Delete AI report",
                    delete_ai_prompts: "Delete prompts",
                    delete_collection_column: "Delete collection column",
                    delete_collection_keywords: "Remove keywords from collection",
                    delete_content_folder: "Delete content folder",
                    delete_content_project: "Delete content project",
                    delete_content_workflow: "Delete workflow",
                    delete_hidden_competitors: "Remove hidden competitor",
                    delete_monitoring_folder: "Delete monitoring folder",
                    delete_monitoring_project: "Delete monitoring project",
                    delete_monitoring_project_category: "Delete monitoring category",
                    delete_monitoring_project_keywords: "Remove keywords from monitoring project",
                    delete_research_collection: "Delete collection",
                    delete_research_project: "Delete research project",
                    delete_objects: "Delete objects",
                    remove_collection_from_research_project: "Remove collection from research project",
                    remove_content_workflow_stage: "Remove workflow stage",
                    remove_content_workflow_task: "Remove workflow task",
                    publish_ai_project_report: "Publish AI report (public link)",
                    publish_content_project_section: "Publish content section (public link)",
                    publish_research_collection: "Publish collection (public link)"
                }
                return labels[name] || String(name || "").replace(/_/g, " ")
            },
            // delete_objects-Argumente ({ items: [{ type, id, name, label }] }) -> eine lesbare Zeile je Objekt.
            // null, wenn die Argumente nicht lesbar sind - dann greift die normale Darstellung.
            approvalObjects(argumentsJson) {
                let args = null
                try {
                    args = JSON.parse(argumentsJson)
                } catch (e) {
                    return null
                }
                const items = args && Array.isArray(args.items) ? args.items : null
                if (!items || !items.length) return null
                const types = {
                    research_collection: "Collection",
                    research_project: "Research project",
                    monitoring_project: "Monitoring project",
                    monitoring_folder: "Monitoring folder",
                    ai_project: "AI project",
                    ai_project_report: "AI report",
                    content_project: "Content project",
                    content_folder: "Content folder"
                }
                return items.map((item) => {
                    const kind = types[item && item.type] || String((item && item.type) || "Object")
                    const shown = (item && (item.label || item.name || item.id)) || "?"
                    return `${kind}: ${shown}`
                })
            },
            // Kurzfassung der Tool-Argumente für die Freigabe (Namen, IDs, Keywords) - technische Felder weg.
            // Aendernde Tool-Aufrufe (create/update/add/delete ...) bekommen eine Zeile mit ihren Argumenten, IDs als
            // Namen aus den Listenergebnissen des Chats. Gibt die ID->Name-Zuordnung zurueck (auch fuer die Freigabe).
            describeChangeCalls(tables, history) {
                const idNames = buildIdNameMap(collectOutputs(history, tables))
                for (const table of tables) {
                    if (isChangeTool(table.name)) table.details = this.approvalDetails(table.arguments, idNames)
                }
                return idNames
            },
            // idNames: ID -> Name aus den Listenergebnissen des Chats (siehe approvalNames.js), damit der Nutzer sieht,
            // WAS er löscht, nicht nur eine ID.
            approvalDetails(argumentsJson, idNames = null) {
                let args = null
                try {
                    args = JSON.parse(argumentsJson)
                } catch (e) {
                    return ""
                }
                if (!args || typeof args !== "object") return ""
                const parts = []
                for (const [key, value] of Object.entries(args)) {
                    if (key === "response_mode" || key === "key" || value === null || value === undefined || value === "") continue
                    let shown
                    if (Array.isArray(value)) {
                        shown = value.slice(0, 5).map((v) => (typeof v === "object" ? JSON.stringify(v) : String(v))).join(", ") + (value.length > 5 ? ` (+${value.length - 5})` : "")
                    } else if (typeof value === "object") {
                        continue
                    } else {
                        shown = String(value)
                    }
                    const resolved = key === "id" || key.endsWith("_id") ? describeId(shown, idNames) : shown
                    // Name bekannt: "folder: Kunde Alpha (id 6ad623e9)", sonst bleibt es bei "folder id: 6ad623e9..."
                    const label = resolved !== shown && key.endsWith("_id") ? key.slice(0, -3).replace(/_/g, " ") : key.replace(/_/g, " ")
                    parts.push(`${label}: ${resolved.length > 60 ? resolved.slice(0, 57) + "..." : resolved}`)
                }
                const text = parts.join(" · ")
                return text.length > 200 ? text.slice(0, 197) + "..." : text
            },
            // ---- Ende Teil 14 ----
            // ---- Datenquellen unter einer KI-Nachricht gebündelt ----
            // Ein Eintrag je Tool (Reihenfolge des ersten Aufrufs), mehrere Aufrufe desselben Tools zusammengefasst:
            // Anzahl als Badge, die Zeilen aller Aufrufe zu EINER Tabelle für "Visualize" zusammengeführt.
            // Gecacht je tables-Array (wird nach dem Anlegen der Nachricht nicht mehr verändert).
            groupSources(tables) {
                if (!Array.isArray(tables) || !tables.length) return []
                const cached = SOURCE_GROUP_CACHE.get(tables)
                if (cached) return cached
                const byName = new Map()
                for (const table of tables) {
                    const name = (table && table.name) || "unknown"
                    if (!byName.has(name)) byName.set(name, { name, count: 0, listRows: [], valueRows: [], outputs: [], details: [] })
                    const group = byName.get(name)
                    group.count++
                    group.outputs.push(table.rawOutput)
                    if (table.details && !group.details.includes(table.details)) group.details.push(table.details)
                    // Echte Listenzeilen getrennt von der Schlüssel/Wert-Notlösung halten: ein leeres Ergebnis
                    // (reports: [], total: 0) liefert dort eine Zeile "total: 0", die in der zusammengeführten
                    // Tabelle zwischen den echten Zeilen stünde.
                    const { rows, path } = extractTableRows(table.rawOutput)
                    const target = typeof path === "string" && path.endsWith(" (Werte)") ? group.valueRows : group.listRows
                    for (const row of rows) target.push(row)
                }
                for (const group of byName.values()) group.rows = group.listRows.length ? group.listRows : group.valueRows
                const groups = [...byName.values()].map((group, idx) => ({
                    name: group.name,
                    label: this.sourceLabel(group.name),
                    count: group.count,
                    // Argumente aendernder Aufrufe (create/update/delete ...), Namen statt IDs - siehe describeChangeCalls
                    details: group.details,
                    rowCount: group.rows.length,
                    rawOutput: group.count === 1 ? group.outputs[0] : { data: group.rows },
                    rawOutputs: group.outputs, // ungefilterte Antworten aller Aufrufe - für "Raw"
                    // eindeutig je Gruppe (auch über Nachrichten hinweg) - Schlüssel für loadingTable und tableDefCache
                    cacheKey: "src:" + ++sourceGroupSeq + ":" + idx + ":" + group.name
                }))
                SOURCE_GROUP_CACHE.set(tables, groups)
                return groups
            },
            // Lösch-/Entfernen-Tools (inkl. delete_objects): ihre Antwort ist nur eine Erfolgsmeldung - kein Visualize.
            isWriteSource(name) {
                return /^(delete|remove)_/.test(String(name || ""))
            },
            // Rohdaten einer Quellen-Gruppe: eine Antwort direkt, mehrere als [{ call, output }]. Sehr große Antworten
            // werden in der Ansicht gekürzt (ein <pre> mit mehreren MB blockiert den Browser), Copy kopiert immer alles.
            showRawSource(group) {
                const outputs = Array.isArray(group.rawOutputs) && group.rawOutputs.length ? group.rawOutputs : [group.rawOutput]
                const value = outputs.length === 1 ? outputs[0] : outputs.map((output, idx) => ({ call: idx + 1, output }))
                let text = ""
                try {
                    text = JSON.stringify(value, null, 2)
                } catch (e) {
                    text = String(value)
                }
                this.rawDialogFull = text
                this.rawDialogShown = text.length > RAW_PREVIEW_CHARS ? text.slice(0, RAW_PREVIEW_CHARS) + "\n\n... (truncated - Copy copies the complete data)" : text
                this.rawDialogTitle = group.label + (outputs.length > 1 ? ` · ${outputs.length} calls` : "")
                this.rawDialog = true
            },
            async copyRawSource() {
                try {
                    await navigator.clipboard.writeText(this.rawDialogFull)
                    this.showChatInfo("Raw data copied.")
                } catch (e) {
                    this.showChatInfo("Could not copy - please select the text manually.", "error")
                }
            },
            showChatInfo(text, color = "primary") {
                this.chatInfoColor = color
                this.chatInfoMessage = text
            },
            sourcesSummary(tables) {
                const calls = Array.isArray(tables) ? tables.length : 0
                const tools = this.groupSources(tables).length
                if (calls === tools) return `${calls} ${calls === 1 ? "query" : "queries"}`
                return `${calls} queries from ${tools} ${tools === 1 ? "tool" : "tools"}`
            },
            // Eine einzelne Quelle ist schon kompakt und steht offen da; mehrere sind eingeklappt.
            sourcesOpen(i) {
                const key = this.activeChatIndex + ":" + i
                if (Object.prototype.hasOwnProperty.call(this.openSources, key)) return this.openSources[key]
                const message = this.messages[i]
                return this.groupSources(message && message.tables).length === 1
            },
            toggleSources(i) {
                this.$set(this.openSources, this.activeChatIndex + ":" + i, !this.sourcesOpen(i))
            },
            // get_backlink_summary -> "Backlink summary", list_ai_project_reports -> "AI project reports"
            sourceLabel(name) {
                const words = String(name || "")
                    .replace(/^(get|list)_/, "")
                    .split("_")
                    .filter(Boolean)
                    .map((word) => ({ ai: "AI", serp: "SERP", kpis: "KPIs", url: "URL", seo: "SEO", llm: "LLM", wdfidf: "WDF*IDF" }[word] || word))
                if (!words.length) return String(name || "")
                const first = words[0]
                words[0] = first === first.toUpperCase() ? first : first.charAt(0).toUpperCase() + first.slice(1)
                return words.join(" ")
            },
            async sendPublic() {
                if (!this.input || this.loading) return
                this.cancelRequested = false
                this.requestController = new AbortController()
                const userInput = this.input
                const userMessage = { user: this.getUsername(), text: userInput, date: new Date() }
                this.publicMessages.push(userMessage)
                this.input = ""
                this.loading = true
                this.slowHint = false
                this.slowHintTimer = setTimeout(() => {
                    this.slowHint = true
                }, 15000)
                this.$nextTick(() => {
                    const el = this.$el.querySelector(".chat-messages-scroll")
                    if (el) el.scrollTop = el.scrollHeight
                })
                let res = null
                let retries = 3
                let lastError = null
                const kopValue = this.getCookie("kop")
                for (let attempt = 1; attempt <= retries; attempt++) {
                    if (this.cancelRequested) break
                    try {
                        res = await this.$helpers.axiosPost(
                            process.env.VUE_APP_APIURL + "/v2/sources/seo-ai/open",
                            {
                                question: userInput,
                                files: this.files,
                                resp_id: localStorage.resp_id,
                                token: localStorage.kop || kopValue
                            },
                            { signal: this.requestController.signal, timeout: 290000 }
                        )
                        lastError = null
                        break
                    } catch (e) {
                        if (this.cancelRequested || e?.name === "AbortError" || e?.code === "ERR_CANCELED") {
                            lastError = null
                            break
                        }
                        lastError = e
                        if (e.message === "Network Error" && attempt < retries) {
                            await new Promise((resolve) => setTimeout(resolve, 1000))
                            continue
                        } else {
                            break
                        }
                    }
                }
                this.requestController = null
                this.files = []
                clearTimeout(this.slowHintTimer)
                this.slowHint = false
                if (this.cancelRequested) {
                    this.loading = false
                    this.cancelRequested = false
                    return
                }
                if (lastError) {
                    let errorMsg = "An error occurred. Please try again."
                    if (lastError.code === "ECONNABORTED") {
                        errorMsg = "The analysis took too long and timed out. Try a narrower question or try again."
                    } else if (lastError.response && lastError.response.status === 504) {
                        errorMsg = "The connection to the server was interrupted. Please try again."
                    } else if (lastError.message === "Network Error" || (lastError.response && lastError.response.status === 0) || !lastError.response) {
                        errorMsg = "A network error occurred. Please check your connection and try again."
                    } else if (lastError.response && lastError.response.status === 429) {
                        errorMsg = "Too many requests. Please try again later."
                    } else if (lastError.response && lastError.response.status === 403) {
                        errorMsg = "Out of credits. Please contact support or upgrade your plan."
                    }
                    this.publicMessages.push({ user: "KI", text: errorMsg, date: new Date() })
                    this.loading = false
                    this.$nextTick(() => {
                        const el = this.$el.querySelector(".v-card-text")
                        if (el) el.scrollTop = el.scrollHeight
                    })
                    return
                }
                const mcpTables = []
                const mcpCalls = res.data.messages?.filter((m) => m.type === "mcp_call") || []
                for (const mcp of mcpCalls) {
                    if (mcp.output) {
                        try {
                            const output = JSON.parse(mcp.output)
                            mcpTables.push({ name: mcp.name || "", rawOutput: output, arguments: typeof mcp.arguments === "string" ? mcp.arguments : "" })
                        } catch (e) {}
                    }
                }
                this.describeChangeCalls(mcpTables, this.publicMessages)
                const kiMessage = {
                    user: "KI",
                    text: res.data.messages?.[res.data.messages.length - 1]?.content?.[res.data.messages[res.data.messages.length - 1].content.length - 1]?.text || "Keine Antwort erhalten.",
                    date: new Date(),
                    tables: mcpTables
                }
                this.publicMessages.push(kiMessage)
                localStorage.resp_id = res.data.resp_id
                this.loading = false
                this.$nextTick(() => {
                    const el = this.$el.querySelector(".v-card-text")
                    if (el) el.scrollTop = el.scrollHeight
                })
            },
            getCookie(name) {
                const value = "; " + document.cookie
                const parts = value.split("; " + name + "=")
                if (parts.length === 2) {
                    return parts.pop().split(";").shift()
                }
                return null
            },
            async notifyAdminError(e, userInput, responseData) {
                let errorPayload
                try {
                    // Fehlerdaten möglichst robust serialisieren
                    errorPayload = {
                        type: "Error",
                        data: {
                            message: e?.message || String(e),
                            stack: e?.stack || null,
                            response: e?.response
                                ? {
                                      status: e.response.status,
                                      data: typeof e.response.data === "object" ? JSON.stringify(e.response.data) : String(e.response.data)
                                  }
                                : undefined,
                            context: {
                                userInput,
                                user_id: localStorage.id,
                                company_id: localStorage.company_id
                            },
                            responseData: responseData ? (typeof responseData === "object" ? JSON.stringify(responseData) : String(responseData)) : undefined
                        },
                        user: localStorage.username,
                        company_id: localStorage.company_id
                    }
                    await this.$helpers.axiosPost(process.env.VUE_APP_APIURL + "/service/notify/admin", errorPayload)
                } catch (notifyErr) {
                    // Fallback: Minimaler Call ohne Daten, damit der Admin trotzdem informiert wird
                    try {
                        await this.$helpers.axiosPost(process.env.VUE_APP_APIURL + "/service/notify/admin", {
                            type: "Error",
                            data: {
                                message: "Error notification failed",
                                originalError: e && e.message ? e.message : String(e),
                                notifyError: notifyErr && notifyErr.message ? notifyErr.message : String(notifyErr)
                            },
                            user: localStorage.username || "-",
                            company_id: localStorage.company_id || "-"
                        })
                    } catch {
                        // Letzter Fallback: Nur loggen, keine weitere Aktion möglich
                        console.log("Admin notification failed completely", notifyErr)
                    }
                }
            },
            // Dummy for username, replace with your logic if needed
            getUsername() {
                try {
                    if (localStorage.username && this.CryptoJS && process.env.VUE_APP_ENCRYPTION_PW) {
                        return this.CryptoJS.AES.decrypt(localStorage.username, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    }
                } catch (e) {}
                return "You"
            },
            formatDate(date) {
                if (!date) return ""
                const d = new Date(date)
                return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
            },
            resolveNested(item, col) {
                if (!col.includes(".")) return item[col]
                const [main, sub] = col.split(".")
                return item[main] && typeof item[main] === "object" ? item[main][sub] : ""
            },
            // For real-time: call this on socket event
            receive(msg) {
                if (this.isPublic) {
                    this.publicMessages.push(msg)
                } else {
                    // gezielt in den aktuell aktiven Chat
                    this.addMessageToChat(msg, this.activeChatIndex)
                }
                if (!this.chatOpen) this.unreadCount++
            },
            async showTable(table) {
                // Gebündelte Quellen bringen einen festen Schlüssel mit (sonst würde jedes Rendern die ggf.
                // zusammengeführte Ausgabe erneut serialisieren).
                const cacheKey = table.cacheKey || JSON.stringify(table.rawOutput)
                this.selectedTable = null
                this.tableDialog = false
                this.$set(this.loadingTable, cacheKey, true) // Nur diesen Button auf loading

                // Zeilen selbst ermitteln statt table_def.source_field: Quaro-Tools liefern {data, meta} statt
                // items[] (siehe helper/mcpTableRows.js) - bisher kam bei ihnen nichts an.
                const { rows } = extractTableRows(table.rawOutput)

                if (this.tableDefCache[cacheKey]) {
                    const table_def = this.tableDefCache[cacheKey]
                    let items = rows
                    this.selectedTable = {
                        name: table.label || table.name || "",
                        columns: table_def.columns,
                        items,
                        chart: table_def.chart
                    }
                    this.tableDialog = true
                    this.$set(this.loadingTable, cacheKey, false)
                    return
                }

                try {
                    // Für die Spaltendefinition reicht eine Stichprobe - spart Tokens bei langen Listen.
                    const res = await this.$helpers.axiosPost(process.env.VUE_APP_APIURL + "/v2/sources/mcp/tabledef", { output: rows.slice(0, 30) })
                    console.log(res.data.table_def)
                    const table_def = res.data.table_def
                    this.tableDefCache[cacheKey] = table_def
                    let items = rows
                    this.selectedTable = {
                        name: table.label || table.name || "",
                        columns: table_def.columns,
                        items,
                        chart: table_def.chart
                    }
                    this.tableDialog = true
                } catch (e) {
                    console.log(e)
                    this.showChatInfo("Could not load the table. Please try again.", "error")
                }
                this.$set(this.loadingTable, cacheKey, false)
            },
            onTableDialogInput(val) {
                this.tableDialog = val
                if (!val) this.selectedTable = null
            },
            startVoiceInput() {
                if (this.recognition) {
                    if (this.recognizing) {
                        this.recognition.stop()
                        this.recognizing = false
                    } else {
                        this.recognition.start()
                        this.recognizing = true
                    }
                }
            },
            // Titel für Dropdown ableiten
            chatTitle(chat) {
                if (chat?.title && chat.title.trim()) return chat.title
                const firstUserMsg = (chat?.messages || []).find((m) => m && m.user && m.user !== "KI")
                return firstUserMsg ? (firstUserMsg.text || "Neuer Chat").slice(0, 40) : "Neuer Chat"
            },
            // Auswahl wechseln
            chooseChat(index) {
                // Chatwechsel sperren während loading
                if (this.loading) return
                if (typeof index !== "number") return
                const s = this.$store.state.user_settings.ki_chats
                if (!s || !Array.isArray(s.chats) || !s.chats[index]) return

                const prevIndex = s.active_chat
                const prevChat = s.chats[prevIndex]

                // Leeren ephemeren Chat vor dem Wechsel entfernen (nie speichern)
                if (prevChat && prevChat.ephemeral && (!prevChat.messages || prevChat.messages.length === 0)) {
                    s.chats.splice(prevIndex, 1)
                    if (index > prevIndex) index -= 1
                    if (s.active_chat > prevIndex && s.active_chat > 0) s.active_chat -= 1
                }

                if (!s.chats[index]) {
                    index = Math.max(0, Math.min(index, s.chats.length - 1))
                }

                s.active_chat = index
                this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)
                this.input = ""
                this.$nextTick(() => {
                    const el = this.$el.querySelector(".chat-messages-scroll")
                    if (el) el.scrollTop = el.scrollHeight
                })
                console.log(this.$store.state.user_settings.ki_chats.chats[index])
            },
            // Max 30 Chats behalten
            enforceChatLimit() {
                const s = this.$store.state.user_settings?.ki_chats
                if (!s || !Array.isArray(s.chats)) return
                const MAX = 30
                while (s.chats.length > MAX) {
                    s.chats.shift()
                    if (typeof s.active_chat === "number" && s.active_chat > 0) s.active_chat--
                }
                this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)
            },
            // Neuen Chat starten (mit Limit und Sperre bei loading)
            startNewChat(ephemeral = false) {
                if (this.loading) return
                const s = this.$store.state.user_settings.ki_chats

                // Wenn ein leerer, ephemerer Chat aktiv ist und wir einen persistierenden Chat starten,
                // entferne ihn vorher (damit er nie gespeichert wird).
                if (!ephemeral) {
                    const curIdx = s.active_chat
                    const cur = s.chats[curIdx]
                    if (cur && cur.ephemeral && (!cur.messages || cur.messages.length === 0)) {
                        s.chats.splice(curIdx, 1)
                        if (s.active_chat >= s.chats.length) s.active_chat = Math.max(0, s.chats.length - 1)
                    }
                }

                const newChat = {
                    id: Date.now(),
                    title: "Neuer Chat",
                    messages: [],
                    created: new Date(),
                    latest_resp_id: null
                }
                if (ephemeral) newChat.ephemeral = true

                s.chats.push(newChat)
                s.active_chat = s.chats.length - 1

                // Nur bei nicht-ephemeren Chats Limit prüfen und speichern
                if (!ephemeral) {
                    this.enforceChatLimit()
                    this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)
                }
            },
            // Nachrichten hinzufügen – zielgerichtet per Index (Snapshot)
            // ---- Teil 10: asynchroner Chat-Job (Socket-Signal + HTTP-Abruf statt blockierendem POST) ----
            generateClientJobId() {
                try {
                    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID()
                } catch (e) {}
                return "job_" + Date.now() + "_" + Math.random().toString(36).slice(2)
            },
            // Fehler beim kurzen Job-Erstellungs-Request selbst (Netz weg, 429, 403 ...) - derselbe
            // Wortlaut wie vor Teil 10, nur ohne den anschließenden Retry.
            mapChatSendErrorMessage(error) {
                if (error.code === "ECONNABORTED") return "The analysis took too long and timed out. Try a narrower question or try again."
                if (error.response && error.response.status === 504) return "The connection to the server was interrupted. Please try again."
                if (error.message === "Network Error" || (error.response && error.response.status === 0) || !error.response) return "A network error occurred. Please check your connection and try again."
                if (error.response && error.response.status === 429) return "Too many requests. Please try again later."
                if (error.response && error.response.status === 403) return "Out of credits. Please contact support or upgrade your plan."
                return "An error occurred. Please try again."
            },
            // Fehler, die der Job selbst gemeldet hat (chatJobController: "lost", "timeout", "upstream_…", "unknown").
            mapChatJobErrorMessage(code) {
                if (code === "lost") return "The connection to the analysis was lost. Please try again."
                if (code === "timeout") return "The analysis took too long and timed out. Try a narrower question or try again."
                return "An error occurred. Please try again."
            },
            // Baut die KI-Nachricht aus einer Antwort im Bestandsformat { messages, resp_id } - egal ob
            // sie synchron (Übergangs-Pfad) oder ueber den Job-Abruf hereinkam.
            applyChatAnswer(data, target) {
                const mcpTables = []
                const mcpCalls = data?.messages?.filter((m) => m.type === "mcp_call") || []
                for (const mcp of mcpCalls) {
                    if (mcp.output) {
                        try {
                            const output = JSON.parse(mcp.output)
                            mcpTables.push({ name: mcp.name || "", rawOutput: output, arguments: typeof mcp.arguments === "string" ? mcp.arguments : "" })
                        } catch (e) {}
                    }
                }
                const history = target.mode === "public" ? this.publicMessages : this.$store.state.user_settings?.ki_chats?.chats?.[this.resolveChatIndex(target)]?.messages
                const idNames = this.describeChangeCalls(mcpTables, history)
                // Teil 14: Eine Antwort, die auf eine Freigabe wartet, endet mit mcp_approval_request statt mit
                // einer Textnachricht - der Text kommt dann aus der letzten message (falls das Modell vorab etwas
                // geschrieben hat), sonst ein fester Hinweis über den Buttons.
                const approvalRequests = (data?.messages || []).filter((m) => m && m.type === "mcp_approval_request" && m.id)
                let text = data?.messages?.[data.messages.length - 1]?.content?.[data.messages[data.messages.length - 1].content.length - 1]?.text
                if (approvalRequests.length) {
                    const lastMessage = [...data.messages].reverse().find((m) => m && m.type === "message")
                    text = lastMessage?.content?.[lastMessage.content.length - 1]?.text || "Please confirm before I run this:"
                }
                const kiMessage = {
                    user: "KI",
                    text: text || "Keine Antwort erhalten.",
                    date: new Date(),
                    tables: mcpTables
                }
                // Verbrauch dieser Antwort (Tokens / Nachricht / Research-Lookups), vom Backend mitgeliefert
                if (data && data.credits_consumed && typeof data.credits_consumed === "object") kiMessage.credits = data.credits_consumed
                if (approvalRequests.length && data?.resp_id) {
                    kiMessage.approval = {
                        resp_id: data.resp_id,
                        state: "pending",
                        requests: approvalRequests.map((req) => {
                            // Teil 15: Sammel-Löschen zeigt jedes Objekt einzeln statt einer gekürzten Argument-Zeile
                            const items = req.name === "delete_objects" ? this.approvalObjects(req.arguments) : null
                            if (items) return { id: req.id, name: req.name, label: `Delete ${items.length} ${items.length === 1 ? "object" : "objects"}`, details: "", items }
                            return { id: req.id, name: req.name || "", label: this.approvalLabel(req.name), details: this.approvalDetails(req.arguments, idNames) }
                        })
                    }
                }
                if (target.mode === "public") {
                    this.publicMessages.push(kiMessage)
                    if (data?.resp_id) localStorage.resp_id = data.resp_id
                } else {
                    this.addMessageToChat(kiMessage, this.resolveChatIndex(target), data?.resp_id)
                }
                this.$nextTick(() => {
                    const el = this.$el.querySelector(".v-card-text")
                    if (el) el.scrollTop = el.scrollHeight
                })
            },
            persistPendingChatJob() {
                try {
                    if (this.pendingJob) sessionStorage.setItem(CHAT_JOB_STORAGE_KEY, JSON.stringify(this.pendingJob))
                } catch (e) {}
            },
            clearPersistedChatJob() {
                try {
                    sessionStorage.removeItem(CHAT_JOB_STORAGE_KEY)
                } catch (e) {}
            },
            // Reload waehrend einer laufenden Analyse: den Job-Raum wieder betreten und den Status
            // sofort nachladen (deckt ein waehrend der Ladezeit verpasstes chatJobUpdate-Event ab).
            restorePendingChatJob() {
                if (this.isPublic) return // /kai (sendPublic) laeuft weiterhin auf dem alten, blockierenden Pfad
                let stored = null
                try {
                    const raw = sessionStorage.getItem(CHAT_JOB_STORAGE_KEY)
                    if (raw) stored = JSON.parse(raw)
                } catch (e) {}
                if (!stored || !stored.job_id) return
                this.pendingJob = stored
                this.loading = true
                this.slowHint = true // die Analyse laeuft schon eine Weile - nicht erst wieder 15s warten
                this.$socket.emit("joinChatJob", this.pendingJob.job_id)
                this.pollPendingChatJob()
                this.startChatWatchdog()
            },
            // Ein Reconnect (Netz-Aussetzer, Relay-Neustart) laesst die Raum-Mitgliedschaft server-seitig
            // verwaisen - wieder beitreten und den Status einmal nachladen, falls das Fertig-Event
            // waehrend der Unterbrechung kam (connectionStateRecovery deckt nur kurze Aussetzer ab).
            onChatSocketReconnect() {
                if (this.pendingJob) {
                    this.$socket.emit("joinChatJob", this.pendingJob.job_id)
                    this.pollPendingChatJob()
                }
            },
            onChatJobUpdate(data) {
                if (!this.pendingJob || !data || data.job_id !== this.pendingJob.job_id) return
                if (data.status === "done" || data.status === "error" || data.status === "cancelled") this.pollPendingChatJob()
            },
            async pollPendingChatJob() {
                if (!this.pendingJob) return
                const job = this.pendingJob
                try {
                    const res = await this.$helpers.axiosPost(process.env.VUE_APP_APIURL + "/v2/sources/chat-job", {
                        user_id: localStorage.id,
                        company_id: localStorage.company_id,
                        job_id: job.job_id
                    })
                    const view = res?.data
                    if (!view || view.status === "queued" || view.status === "running") return // noch nicht fertig, weiter auf das Socket-Event bzw. den Watchdog warten
                    this.finishPendingChatJob(job, view)
                } catch (e) {
                    // Statusabruf selbst fehlgeschlagen (kurzer Netz-Aussetzer) - keine Fehlermeldung an den
                    // Nutzer, der Watchdog fragt in Kuerze erneut nach.
                }
            },
            finishPendingChatJob(job, view) {
                if (this.pendingJob !== job) return // inzwischen schon durch ein anderes Event/den Watchdog abgeschlossen
                this.$socket.emit("leaveChatJob", job.job_id)
                this.pendingJob = null
                this.clearPersistedChatJob()
                this.clearChatWatchdog()
                this.loading = false
                this.slowHint = false
                clearTimeout(this.slowHintTimer)
                if (view.status !== "done") this.markApprovalFailed(job) // Teil 14
                if (view.status === "done") {
                    this.applyChatAnswer(view.answer, job)
                } else if (view.status !== "cancelled") {
                    // "cancelled" ist immer nutzerinitiiert (siehe cancelRequest) - keine zusaetzliche Fehlermeldung
                    const message = { user: "KI", text: this.mapChatJobErrorMessage(view.error), date: new Date() }
                    if (job.mode === "public") this.publicMessages.push(message)
                    else this.addMessageToChat(message, this.resolveChatIndex(job))
                }
            },
            // Ziel-Chat eines Jobs: bevorzugt ueber die Chat-id (stabil ueber enforceChatLimit/Reload),
            // sonst der beim Absenden gemerkte Index.
            resolveChatIndex(target) {
                const chats = this.$store.state.user_settings?.ki_chats?.chats || []
                if (target.chatId != null) {
                    const idx = chats.findIndex((c) => c && c.id === target.chatId)
                    if (idx >= 0) return idx
                }
                return target.targetIdx
            },
            startChatWatchdog() {
                this.clearChatWatchdog()
                this.chatWatchdogAttempts = 0
                this.chatWatchdogTimer = setTimeout(() => this.runChatWatchdogCycle(), CHAT_JOB_WATCHDOG_MS)
            },
            async runChatWatchdogCycle() {
                if (!this.pendingJob) return
                this.chatWatchdogAttempts++
                await this.pollPendingChatJob()
                if (!this.pendingJob) return // pollPendingChatJob hat den Job inzwischen abgeschlossen
                if (this.chatWatchdogAttempts < 3) {
                    this.chatWatchdogTimer = setTimeout(() => this.runChatWatchdogCycle(), 60000)
                } else {
                    // Mehrere Versuche ohne Ergebnis - dem Nutzer sagen, dass die Verbindung verloren ist,
                    // statt endlos "thinking..." zu zeigen.
                    this.finishPendingChatJob(this.pendingJob, { status: "error", error: "lost" })
                }
            },
            clearChatWatchdog() {
                if (this.chatWatchdogTimer) clearTimeout(this.chatWatchdogTimer)
                this.chatWatchdogTimer = null
            },
            // ---- Ende Teil 10 ----
            addMessageToChat(message, chatIndex, resp_id = null) {
                const chats = this.$store.state.user_settings.ki_chats.chats
                if (chats[chatIndex]) {
                    const chat = chats[chatIndex]
                    // Ab erster Nachricht ist der Chat nicht mehr ephemer
                    if (chat.ephemeral) delete chat.ephemeral
                    chat.messages.push(message)
                    if (resp_id) chat.latest_resp_id = resp_id
                }
                // Jetzt persistieren (erst ab erster Nachricht)
                this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)
            },
            cancelRequest() {
                this.cancelRequested = true
                try {
                    if (this.requestController?.abort) this.requestController.abort()
                } catch (_) {}
                if (this.pendingJob) {
                    // Relayed an genau den Worker, der den Job haelt (backend_socket_id) - analog zu
                    // stopContentGeneration beim Editor-Stream.
                    this.$socket.emit("stopChatJob", { job_id: this.pendingJob.job_id, backend_socket_id: this.pendingJob.backend_socket_id })
                    this.$socket.emit("leaveChatJob", this.pendingJob.job_id)
                    this.markApprovalFailed(this.pendingJob) // Teil 14: abgebrochene Freigabe-Ausführung
                    this.pendingJob = null
                    this.clearPersistedChatJob()
                    this.clearChatWatchdog()
                }
                this.loading = false
                this.requestController = null
            },
            // Edit-Dialog für Chat-Titel öffnen
            openEditChat(index) {
                if (this.loading) return
                const chat = this.chats[index]
                if (!chat) return
                this.editChatIndex = index
                this.editTitle = chat.title || ""
                this.editDialog = true
            },
            // Chat-Titel speichern
            saveEditChat() {
                if (this.loading || this.editChatIndex === null) return
                const title = (this.editTitle || "").trim()
                if (!title) {
                    this.editDialog = false
                    return
                }

                const s = this.$store.state.user_settings?.ki_chats
                if (!s?.chats?.[this.editChatIndex]) return

                s.chats[this.editChatIndex].title = title
                this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)

                this.editDialog = false
                this.editTitle = ""
                this.editChatIndex = null
            },
            // Chat löschen
            deleteChat(index) {
                if (this.loading) return
                const s = this.$store.state.user_settings?.ki_chats
                if (!s || !Array.isArray(s.chats) || !s.chats[index]) return

                s.chats.splice(index, 1)

                if (!s.chats.length) {
                    // Persistiere die Löschung (kein leerer Chat wird gespeichert)
                    s.active_chat = 0
                    this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)

                    // UX: ephemeren Platzhalter lokal hinzufügen (nicht persistieren)
                    s.chats.push({ id: Date.now(), title: "Neuer Chat", messages: [], created: new Date(), latest_resp_id: null, ephemeral: true })
                    s.active_chat = s.chats.length - 1
                } else {
                    if (s.active_chat >= s.chats.length) s.active_chat = s.chats.length - 1
                    else if (index <= s.active_chat && s.active_chat > 0) s.active_chat -= 1
                    this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)
                }
            },

            // Nach erster User-Nachricht automatisch benennen
            maybeRenameChat(index, text) {
                const s = this.$store.state.user_settings?.ki_chats
                const chat = s?.chats?.[index]
                if (!chat) return
                const current = (chat.title || "").trim()
                if (!current || current === "Neuer Chat") {
                    chat.title = (text || "").trim().slice(0, 80) || "Neuer Chat"
                    this.$store.dispatch("CHANGE_USER_SETTINGS", this.$store.state.user_settings)
                }
            }
        }
    }
</script>

<style>
    /* Teil 14: Freigabe-Box unter einer KI-Nachricht */
    .chat-approval {
        border: 1px solid #e0e0e0;
        border-radius: 12px;
        padding: 8px 12px;
        background: rgba(0, 0, 0, 0.02);
    }
    .chat-credits {
        display: flex;
        align-items: center;
        font-size: 11px;
        color: rgba(0, 0, 0, 0.5);
    }
    /* Beantwortete Freigabe: deutlich sichtbar, was gedrückt wurde (Bestätigt / Abgebrochen / Fehlgeschlagen / Abgelaufen) */
    .chat-approval-state {
        display: flex;
        align-items: center;
        font-size: 13px;
        font-weight: 500;
        padding: 6px 10px;
        border-radius: 8px;
    }
    .chat-approval-state--approved {
        color: #2e7d32;
        background: rgba(76, 175, 80, 0.12);
    }
    .chat-approval-state--declined {
        color: #424242;
        background: rgba(0, 0, 0, 0.07);
    }
    .chat-approval-state--failed {
        color: #c62828;
        background: rgba(244, 67, 54, 0.1);
    }
    .chat-approval-state--expired {
        color: #616161;
        background: rgba(0, 0, 0, 0.04);
    }
    .chat-approval-item {
        font-size: 13px;
        line-height: 1.6;
        word-break: break-word;
    }
    .chat-approval-objects {
        margin: 2px 0 0 0;
        padding-left: 22px;
        max-height: 220px;
        overflow-y: auto;
    }
    /* Kachel-Liste */
    .chat-tiles {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        grid-gap: 12px;
    }
    .chat-tile {
        cursor: pointer;
    }
    .chat-tile.disabled-card {
        pointer-events: none;
        opacity: 0.7;
        cursor: not-allowed;
    }
    .active-chat-card {
        border: 2px solid var(--v-primary-base);
    }
    .tile-title {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .promptinput .v-input__prepend-outer {
        margin-top: 8px !important;
        margin-right: 5px !important;
        margin-left: 5px !important;
    }
    .promptinput .v-input__append-outer {
        margin-top: 28px !important;
        margin-right: 5px !important;
        margin-left: 5px !important;
    }
    .promptinput {
        /* background-color: #ecf5f3; */

        border: 3px solid #ededed;
    }
    .promptinput .second {
        /* background-color: #ecf5f3; */
        background: rgb(234 234 234 / 40%);
        border-radius: 16px;
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        border: 1px solid rgba(255, 255, 255, 0.3);
        /* border: 3px solid #ededed; */
    }
    .comment-text2 table {
        border-collapse: collapse;
        margin-bottom: 25px;
        font-size: 0.9em;
        font-family: sans-serif;
        min-width: 400px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
        border-radius: 16px; /* Abrundung hinzugefügt */
        overflow: hidden;
    }
    .comment-text2 table thead tr {
        background-color: var(--v-primary-base);
        color: #ffffff;
        text-align: left;
    }

    .comment-text2 table th,
    .comment-text2 table td {
        padding: 12px 15px;
    }
    .comment-text2 table tbody tr {
        border-bottom: 1px solid #dddddd;
    }

    .comment-text2 table tbody tr:nth-of-type(even) {
        background-color: #f3f3f3;
    }

    .comment-text2 table tbody tr:last-of-type {
        border-bottom: 2px solid var(--v-primary-base);
    }
    .comment-text2 th {
        background-color: var(--v-primary-base);
    }
    .comment-text2 td {
        padding: 8px;
        text-align: left;
        border-bottom: 1px solid #ddd !important;
    }
    .comment-area {
        margin-bottom: 10px;
        margin-top: 10px;
    }
    .comment-user {
        margin-left: 5px;
        font-weight: bold;
        font-size: 12px;
        padding-bottom: 6px;
    }
    .comment-date {
        margin-left: 5px;
        font-style: italic;
        font-size: 12px;
    }
    .comment-text2 {
        margin-top: 5px;
        background-color: #ecfef9;
        border-radius: 20px;
        color: #1f1f1f;
        display: inline-block;
        max-width: 100%;
        padding: 10px 12px;
        box-sizing: border-box;
        position: relative;
        width: fit-content;
        font-size: 0.875rem;
        /* line-height: 1.25rem; */
        word-break: break-word;
        word-wrap: break-word;
    }
    .justify-end {
        justify-content: flex-end;
    }
    .ki-message {
        align-items: flex-start;
        margin-right: auto;
    }
    .chat-row-left {
        flex-direction: row;
        justify-content: flex-start;
    }
    .chat-row-right {
        flex-direction: row-reverse;
        justify-content: flex-end;
    }
    .ki-message .comment-text2 {
        background-color: #f7fafc; /* sehr hell, fast weiß */
        color: #222;
        border-radius: 16px 16px 16px 16px;
        border: 2px solid rgb(236 234 235);
    }
    .user-message .comment-text2 {
        background-color: #1976d2;
        color: #fff;
        border-radius: 16px 16px 4px 16px;
        margin-left: auto;
    }
    .user-message {
        align-items: flex-end;
        margin-left: auto;
    }
    .comment-text2 p {
        padding: 0.5rem 0;
    }

    .comment-text2 h1 {
        padding: 1.5rem 0 1rem 0;
    }
    .comment-text2 h2 {
        padding: 1.25rem 0 0.75rem 0;
    }
    .comment-text2 h3 {
        padding: 1rem 0 0.5rem 0;
    }
    .comment-text2 h4,
    .comment-text2 h5,
    .comment-text2 h6 {
        padding: 0.75rem 0 0.25rem 0;
    }

    /* Listen */
    .comment-text2 ul,
    .comment-text2 ol {
        padding: 0.5rem 1.25rem;
        margin: 0;
    }
    .comment-text2 li {
        padding: 0.25rem 0;
    }

    /* Neue Styles für die Chat-Container */
    .chat-flex-container {
        display: flex;
        flex-direction: column;
        height: calc(100vh - 150px);
    }
    @media (max-width: 600px) {
        .chat-messages-container {
            padding: 5px !important;
        }
        .aimainwrap {
            padding: 0 !important;
        }
        .chat-row-left {
            flex-direction: column !important;
        }
    }
    .chat-messages-container {
        background: rgba(255, 255, 255, 0.2);
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(5px);
        border: 1px solid rgba(255, 255, 255, 0.3);
        display: flex;
        flex-direction: column;
        flex: 1;
        padding: 40px;
        overflow: hidden;
        min-height: calc(100vh - 150px);
        max-height: calc(100vh - 150px);
        /* background-color: #f3f3f3; */
        border-radius: 15px;
    }
    .chat-messages-scroll {
        flex: 1 1 auto;
        overflow-y: auto;
        padding-right: 8px;
        padding-left: 8px;
    }
    .chat-input-bar {
        padding-top: 8px;
        padding-bottom: 8px;
        padding-left: 16px;
        padding-right: 16px;
        background-color: #fff;
        border-top: 1px solid #e0e0e0;
        border-radius: 0 0 16px 16px;
    }
    .mic-anim {
        animation: pulse 1s infinite;
    }
    @keyframes pulse {
        0% {
            color: #1976d2;
        }
        50% {
            color: #ff5252;
        }
        100% {
            color: #1976d2;
        }
    }
    .md-table-wrapper .csv-btn,
    .md-table-wrapper .clipboard-btn {
        width: 36px;
        height: 36px;
        min-width: 36px;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .md-table-wrapper .csv-btn {
        background: #64646488;
        color: #fff;
        border: none;
        border-radius: 20px;
        padding: 4px 10px;
        font-size: 0.85em;
        cursor: pointer;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
        transition: background 0.2s;
    }
    .md-table-wrapper .csv-btn:hover {
        background: #646464f1;
    }
    .md-table-wrapper .clipboard-btn {
        background: #64646488;
        color: #fff;
        border: none;
        border-radius: 20px;
        padding: 4px 10px;
        font-size: 0.85em;
        cursor: pointer;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
        transition: background 0.2s;
        margin-right: 8px;
    }
    .md-table-wrapper .clipboard-btn:hover {
        background: #646464f2;
    }
    .chat-history-col {
        position: sticky;
        top: 16px;
        align-self: flex-start;
    }
    .chat-history-card {
        display: flex;
        flex-direction: column;
        height: calc(100vh - 150px);
        border-radius: 15px !important;
        border: 3px solid #ededed !important;
        box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
        backdrop-filter: blur(6px);
        background: rgba(255, 255, 255, 0.221) !important;
        -webkit-backdrop-filter: blur(6px);
        overflow: hidden;
    }
    .chat-history-card .v-card-title {
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        background: linear-gradient(135deg, #f7f9fc 0%, #eef2f7 100%);
        font-weight: 600;
        letter-spacing: 0.2px;
    }

    /* Liste füllt Card und scrollt */
    .chat-history-list {
        flex: 1 1 auto;
        background: rgba(255, 255, 255, 0.222) !important;
        overflow-y: auto;
        padding: 6px 0;
        max-height: none; /* überschreibt ältere Regel */
    }
    .chat-history-list::-webkit-scrollbar {
        width: 8px;
    }
    .chat-history-list::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.18);
        border-radius: 8px;
    }

    /* Items: kompakt, Hover/Active fein */
    .chat-history-list .v-list-item {
        padding: 10px 10px;
        min-height: unset;
    }
    .chat-item {
        position: relative;
        cursor: pointer;
        border-radius: 12px;
        margin: 4px 6px;
        transition: background-color 0.15s ease, transform 0.08s ease, border-color 0.15s ease, box-shadow 0.15s ease;
        border: 1px solid transparent;
        will-change: transform;
    }
    .chat-item:hover {
        background: rgba(0, 0, 0, 0.035);
        transform: translateY(-1px);
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    }
    .chat-item.active {
        background-color: rgba(25, 118, 210, 0.1);
        border-color: rgba(25, 118, 210, 0.25);
    }
    .chat-item.active::before {
        content: "";
        position: absolute;
        left: 0;
        top: 8px;
        bottom: 8px;
        width: 3px;
        background: #1976d2;
        border-radius: 0 2px 2px 0;
    }

    /* Typografie */
    .chat-item-title {
        font-weight: 600;
        font-size: 0.95rem;
        color: #1f1f1f;
        letter-spacing: 0.2px;
    }
    .chat-item-subtitle {
        font-size: 0.82rem;
        color: #616161;
    }

    /* Datums-Pill über dem Titel */
    .chat-item-date {
        display: inline-flex;
        margin: 0 0 6px 0;
        padding: 2px 8px;
        border-radius: 999px;
        line-height: 1.2;
        font-weight: 600;
        font-size: 0.72rem;
        color: #455a64;
        background: rgba(69, 90, 100, 0.08);
    }

    /* Aktionen nur bei Hover/Active sichtbar */
    .chat-item-actions {
        opacity: 0;
        transition: opacity 0.15s ease;
    }
    .chat-item:hover .chat-item-actions,
    .chat-item.active .chat-item-actions {
        opacity: 1;
    }

    /* Zweizeilige Trunkierung für Snippet */
    .text-truncate-2 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    /* Dark Mode: Die Chat-Seite bleibt in BEIDEN App-Themes hell (Glas auf hellem Verlauf, helle Blasen). Früher
       hingen dunkle Regeln an @media (prefers-color-scheme: dark) - bei dunklem Browser und heller App wurde die
       Chat-Liste hellgrau auf hellem Glas. Im dunklen App-Theme erben Texte dagegen Weiß - ebenfalls unlesbar auf
       dem hellen Grund. Deshalb: Text auf dieser Seite immer dunkel. Die Chat-Liste erzwingt das über `light` an
       ihrer v-card, frei stehender Text (Quellen, Freigabe, Namen/Zeiten) hier. Dialoge hängen am App-Root und
       folgen weiter dem App-Theme. */
    .v-application.theme--dark #contentcontainter.chat-flex-container {
        color: rgba(0, 0, 0, 0.87);
    }

    /* Datenquellen unter einer KI-Nachricht (gebündelt, siehe groupSources) */
    .chat-sources {
        max-width: 640px;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        padding: 6px 10px;
        font-size: 13px;
    }
    .chat-sources-head {
        display: flex;
        align-items: center;
        cursor: pointer;
        user-select: none;
    }
    .chat-sources-meta {
        margin-left: 8px;
        opacity: 0.65;
    }
    .chat-sources-list {
        margin-top: 4px;
    }
    .chat-source-row {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 3px 0;
        border-top: 1px solid rgba(0, 0, 0, 0.05);
    }
    .chat-source-details {
        flex: 1 1 auto;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 11px;
        opacity: 0.7;
    }
    .chat-source-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .chat-source-badge {
        flex: none;
        font-size: 11px;
        font-weight: 600;
        padding: 0 6px;
        border-radius: 999px;
        background: rgba(25, 118, 210, 0.1);
        color: #1976d2;
    }
    .chat-source-rows {
        flex: none;
        font-size: 12px;
        opacity: 0.6;
    }
    .chat-raw-json {
        margin: 0;
        padding: 12px 16px;
        font-size: 12px;
        line-height: 1.45;
        white-space: pre-wrap;
        word-break: break-word;
        background: rgba(0, 0, 0, 0.03);
    }
    .v-application.theme--dark .chat-raw-json {
        background: rgba(255, 255, 255, 0.04);
    }
</style>
